import { Button } from '@workramp/ui';
import { useMemo } from 'react';
import { I18n } from '~/common/explicit-exports';
import { useLearnerEventDetails } from '../../hooks/useLearnerEventDetails';

const TRANSLATED_UNREGISTER = I18n.t('js.learner.events.sessions.action_button.unregister');
const TRANSLATED_LEAVE_WAITLIST = I18n.t('js.learner.events.sessions.action_button.leave_waitlist');
const TRANSLATED_CANCEL = I18n.t('common.application.cancel');

export const SecondaryButton = ({ session, isLearnerRegistered, isLearnerWaitlisted, onClose }) => {
  const { onLeaveWaitlist, onUnregister } = useLearnerEventDetails();

  const [secondaryButtonLabel, onPressSecondary] = useMemo<[string, () => void]>(() => {
    if (isLearnerRegistered) {
      return [TRANSLATED_UNREGISTER, () => onUnregister(session.id)];
    }

    if (isLearnerWaitlisted) {
      return [TRANSLATED_LEAVE_WAITLIST, () => onLeaveWaitlist(session.id)];
    }

    return [TRANSLATED_CANCEL, onClose];
  }, [isLearnerRegistered, isLearnerWaitlisted, onClose, onLeaveWaitlist, onUnregister, session.id]);

  return (
    <Button color="secondary" variant="text" onPress={onPressSecondary}>
      {secondaryButtonLabel}
    </Button>
  );
};
